import { AnimationReferenceMetadata, transition, trigger, useAnimation } from '@angular/animations';

/**
 * PSï¼å¨ç»ä¼è¢«ä½¿ç¨å¨ @Component ç animations ä¸­ï¼angular å¨ AOT ç¼è¯æ¶ç¦æ­¢å¨æ³¨è§£ä¸­æ§è¡'é¤ return è¯­å¥å¤è¿åå«å¶ä»è¯­å¥å½æ°'ï¼
 * æ¯å¦ function getName() { return 'xxx' } åæ³ï¼è function getName() { console.log('xxx'); return 'xxx' } ä¼
 * æ¥é(Function calls are not supported in decorators)ï¼æä»¥æ¬æä»¶ä¸­ææå¨ç»å½æ°ç»è¿ç®åå¤çï¼åªæç´æ¥ç return è¯­å¥
 */

export interface AnimOptions {

    duration?: number;

    delay?: number;

    easing?: string;
}

export interface CommonTriggerOptions<A extends AnimOptions, B extends AnimOptions = A> extends AnimOptions {

    enter?: A;

    leave?: B;
}

// tslint:disable-next-line:max-line-length
export function commonTriggerCreator<A extends AnimOptions, B extends AnimOptions, T extends CommonTriggerOptions<A, B>>(
    name: string,
    options: T = {} as T,
    enterHandler: (options: A) => AnimationReferenceMetadata,
    leaveHandler: (options: B) => AnimationReferenceMetadata
) {
    return trigger(name, [
        transition(':enter', [
            useAnimation(
                enterHandler({
                    duration: options.duration,
                    delay: options.delay,
                    easing: options.easing,
                    ...options.enter
                })
            )
        ]),
        transition(':leave', [
            useAnimation(
                leaveHandler({
                    duration: options.duration,
                    delay: options.delay,
                    easing: options.easing,
                    ...options.leave
                })
            )
        ])
    ]);
}